import React, { useState } from 'react'; 
import '@picocss/pico'
import AdminLogin from './components/AdminLogin';
import AdminDashboard from './components/AdminDashboard';

function Admin() {
    const [ adminKey, setAdminKey ] = useState()

    const handleLogin = correctAdminKey => {
        setAdminKey(correctAdminKey)
    }

    return (
        <div className="container">
            { adminKey 
                ? (
                    <AdminDashboard 
                        adminKey={adminKey}
                    />
                )
                : (
                    <AdminLogin
                        setAdminKey={handleLogin}
                    />
                )
            }
        </div>
    )
}

export default Admin;
